export default "__VITE_ASSET__WmM8Ju3p__ 120w, __VITE_ASSET__CUQK4P9i__ 240w, __VITE_ASSET__ByQpA_T0__ 480w, __VITE_ASSET__BbiUH8_n__ 512w";